/**
 * appId
 */
export const WelfareAppId = {
  QB: 0, // 主线版
  QBFF: 2, // 搜狗急速版
  QBNOVEL: 4, // 小说急速版
};
